/**
 * PickTypeTypeahead
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Form
import { RenderDropdown } from '../../../../forms';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    options: {
        id: number,
        name: string
    }[];
    label?: string;
    placeholder?: string;
    name: string;
    validate?: Function | Function[];
    normalize?: Function;
    disabled?: boolean;
}

export class PickTypeTypeahead extends React.PureComponent<Props> {
    render() {
        const {
            options,
            label,
            placeholder,
            name,
            validate,
            normalize,
            disabled
        } = this.props;
        if (!options.length) return null;
        return (
            <Field
                component={RenderDropdown}
                label={label}
                name={name}
                options={options}
                placeholder={placeholder}
                clearable={!disabled}
                fluid
                search
                selection
                validate={validate}
                normalize={normalize}
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions
});

export default connect(mapStateToProps)(PickTypeTypeahead);
